import React from 'react';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    const el = document.getElementById('precio');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="px-4 py-8 md:py-12 max-w-md mx-auto text-center" data-id="element-49">
      <div className="mb-6" data-id="element-50">
        <span className="inline-block bg-sage/20 text-sage-dark font-bold px-3 py-1 rounded-full text-xs tracking-wider uppercase mb-4" data-id="element-51">
          Método Cortisol Zero
        </span>
        <h1 className="text-3xl md:text-4xl font-extrabold leading-tight text-darkslate mb-4" data-id="element-52">
          Dejá de pelearte con el espejo: El método de 14 días para{' '}
          <span className="text-sage-dark" data-id="element-53">desinflamar</span> tu abdomen y
          recuperar tu energía eliminando el Cortisol.
        </h1>
        <p className="text-base md:text-lg text-gray-700 font-medium leading-relaxed" data-id="element-54">
          Si dormís poco, vivís a mil y sentís que tu panza se hincha aunque
          comas una ensalada, tu problema no es la dieta.{' '}
          <span className="font-bold text-darkslate border-b-2 border-sage" data-id="element-55">
            Es tu bioquímica.
          </span>
        </p>
      </div>

      <div className="relative rounded-2xl overflow-hidden shadow-xl border-4 border-white aspect-square bg-sage/10" data-id="element-56">
        <img src="https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?auto=format&fit=crop&q=80&w=800" alt="Persona relajada y desinflamada" className="w-full h-full object-cover" data-id="element-57" />
        <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-black/60 to-transparent p-4 text-white text-left" data-id="element-58">
          <p className="font-semibold text-sm" data-id="element-59">
            Resultados visibles en 14 días
          </p>
        </div>
      </div>

      <button onClick={scrollToPricing} className="mt-6 w-full bg-orange-500 hover:bg-orange-600 text-white font-extrabold py-5 px-6 rounded-xl text-xl uppercase tracking-wide text-center transition-all border-b-4 border-orange-700 active:border-b-0 active:translate-y-1" style={{
      boxShadow: '0 6px 20px 0 rgba(234,88,12,0.45), 0 2px 6px 0 rgba(0,0,0,0.15)'
    }} data-id="element-60">
        ¡RESERVAR MI CUPO CON 65% OFF! ⚡
      </button>
    </section>;
}